import { SETTINGS_ACTIONS } from './settingsActionMap';
import { createScopedDispatchers } from 'shared/helpers/shared/selectHandlers/createScopedDispatchers';

const { selectAllDispatch } = createScopedDispatchers(SETTINGS_ACTIONS, 'switch');

export const selectAllIndicatorDispatcherHandler = (
  dispatch,
  name,
  locationList,
  specificLocationList,
  machineList,
  select = true
) =>
  selectAllDispatch(
    dispatch,
    name,
    locationList,
    specificLocationList,
    machineList,
    select
  );
